module.exports = __webpack_public_path__ + "img/zibo.baea7711.jpg";